import { Component, OnInit, AfterViewInit } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { environment } from '../../../environments/environment';
import { ImageCardComponent } from "../image-card/image-card.component";
import { CountUpModule } from 'ngx-countup';
import { CountUpOptions } from 'countup.js';
@Component({
    selector: 'app-content-card',
    imports: [NgOptimizedImage, ImageCardComponent, CountUpModule],
    templateUrl: './content-card.component.html',
    styleUrl: './content-card.component.scss',
    host: { ngSkipHydration: 'true' },

})
export class ContentCardComponent implements OnInit, AfterViewInit {
    ngOnInit() {
        this.useOptionsAndEndVal();
    }
    ngAfterViewInit() {
        this.delay = false;
        setTimeout(() => {
            this.delay = true;
        }, 500);
    }

    opts: CountUpOptions = {
        enableScrollSpy: true,
    };
    opts1: CountUpOptions = {
        enableScrollSpy: true,
    };
    delay: boolean = false;
    assetsCDNUrl = environment.assetsCDNUrl;
    items = [
        {
            headingPre: '',
            heading: 4700,
            headingBasic: false,
            headingPost: '+',
            para: 'Branch Network across India'
        },
        {
            headingPre: '',
            heading: 115500,
            headingBasic: false,
            headingPost: '+',
            para: 'Employees'
        },
        {
            headingPre: '',
            headingBasic: true,
            heading: 2.9,
            headingPost: 'crore +',
            para: 'Customer Base'
        },
        {
            headingPre: 'INR',
            headingBasic: true,
            heading: 3.69,
            headingPost: 'lakh crore+',
            para: 'Assets'

        }
    ];

    useOptionsAndEndVal() {
        this.opts = {
            decimalPlaces: 0,
            separator: ',',
            duration: 3,
            decimal: '2',

        };
        this.opts1 = {
            decimalPlaces: 0,
            separator: ',',
            duration: 3,
            decimal: '2',
            useIndianSeparators: true,
        };
    }


    cardItem = [
        {
            headingPre: '',
            heading: 29,
            headingBasic: false,
            headingPost: '',
            para: 'Countries (Across Africa, Asia & UK)'
        },
        {
            headingPre: '',
            heading: 149036,
            headingBasic: false,
            headingPost: '+',
            para: 'Employees'
        },

        {
            headingPre: '',
            headingBasic: true,
            heading: 96,
            headingPost: 'million',
            para: 'Lives touched  across Africa & Asia'
        },
        {
            headingPre: 'R1.7',
            // heading: 7,
            headingBasic: true,
            headingPost: 'trillion+',
            para: 'Assets',
            // subText: 'Rand = INR XXX as on 31st December 2023'
        }
    ]

    imageCardData: any = [
        {
            "title": "Who <u>Are We?</u>",
            "sub_title": "<p>Shriram Wealth builds on Shriram Group's 50+ year legacy of trust and on Sanlam's 100+ years of global leadership to create simple, strategic wealth management solutions aligned with your unique goals.</p>",
            "image_url": "/assets/images/golbal.webp",
            "alt_text": "Who Are We?",
        }
    ];

}
